import { render } from "./layout-desktop.vue?vue&type=template&id=6ded80ab"
import script from "./layout-desktop.vue?vue&type=script&lang=js"
export * from "./layout-desktop.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Barbara\\Angopri\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__